
export default {
  name: 'user-icon',
  props: {
    iconSize: {},
    updateProfileSafe: {},
    userProfile: {}
  }
}
